export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline--long.6e85628ef1c851c652acb5560a37c975.svg";